import getNodeOffset from '../plugins/getNodeOffset'

export function clickTouchDown(e, direction) {
  let deviation = direction == 'right' ? -5 : 5
  
  // 存在 e.target 为子节点 获取父节点后再作处理
  let eareBox = e.target.classList.contains('single') ? e.target : e.target.parentNode,
  lineDrop = eareBox.querySelector('.line-drop')

  // 获取坐标 (.line-drop 圆心位置) 以body左上为原点
  let pos1 = {direction: 'move', key: '-1', ...getNodeOffset(lineDrop)}, pos2 = {}
  pos1.left += lineDrop.offsetWidth / 2
  pos1.top += lineDrop.offsetHeight / 2
  
  document.body.ontouchmove = ev => {
    pos2 = {left: ev.pageX - deviation, top: ev.pageY, key: '-1'}

    this.ligature(pos1, pos2, 'body')

    // 只留最后那根线
    while(document.querySelectorAll(`.${pos1.direction}-${pos1.key}-${pos2.key}`).length > 1) {
      let tempLine = document.querySelectorAll(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
      document.body.removeChild(tempLine[0])
    }
  }

  document.body.ontouchend = (ev) => {
    document.body.ontouchmove = null
    document.body.ontouchend = null

    // 消除临时线段
    let tempLine = document.querySelector(`.${pos1.direction}-${pos1.key}-${pos2.key}`)
    
    if(!tempLine) return;
    document.body.removeChild(tempLine)
    
    let singles = document.querySelectorAll('.single')
    let containIdx = null
    for(let i = 0; i < singles.length; i++) {
      let {left, top} = getNodeOffset(singles[i]),
      pageX = ev.pageX,
      pageY = ev.pageY,
      width = singles[i].offsetWidth,
      height = singles[i].offsetHeight,
      item = [left, top, left + width, top + height]

      if(pageX >= item[0] 
        && pageY >= item[1]
        && pageX <= item[2]
        && pageY <= item[3]) {
        containIdx = i
        break;
      } else {
        containIdx = null
      }
    }

    // 获取松开鼠标后停留的节点
    let target = singles[containIdx], nodes = ['line-drop', 'single', 'value', 'image'],
    res = nodes.some(its => {
      // 必须在ligature-list节点内 且 必须是nodes列表中的节点
      if(target.offsetParent && target.offsetParent.classList.contains('ligature-list')
          && target.classList.contains(its)) 
      return true
    })

    // let box = document.querySelector('.question-view')
    // // box.insertAdjacentHTML('afterend', 'target.offsetParent: -> ' + target.offsetParent.classList + '<br/>')
    // // box.insertAdjacentHTML('afterend', 'target Text: -> ' + target.innerText + '<br/>')
    // // box.insertAdjacentHTML('afterend', 'target: -> ' + target.classList + '<br/>')
    // // box.insertAdjacentHTML('afterend', 'eareBox: -> ' + eareBox.classList + '<br/>')
    // // box.insertAdjacentHTML('afterend', 'eareBox Text: -> ' + eareBox.innerText + '<br/>')
    // // box.insertAdjacentHTML('afterend', '是否包含 -> ' + eareBox.contains(target) + '<br/>')
    // // box.insertAdjacentHTML('afterend', res + '<br/>')
    
    // for(let i in eve) {
    //   box.insertAdjacentHTML('afterend', i + '-> ' + eve[i] + '<br/>')
    // }
    // // const lastTouch = eve.changedTouches[eve.changedTouches.length - 1];
    // box.insertAdjacentHTML('afterend', '---------------' + '<br/>')
    // for(let i = 0; i < eve.changedTouches.length; i++) {
    //   box.insertAdjacentHTML('afterend', 'changedTouches -> ' + eve.changedTouches[i].innerHTML + '<br/>')
    // }
    // box.insertAdjacentHTML('afterend', 'changedTouchesleng -> ' + eve.changedTouches.length + '<br/>')
    // for(let i = 0; i < eve.targetTouches.length; i++) {
    //   box.insertAdjacentHTML('afterend', 'targetTouches -> ' + eve.targetTouches[i].innerText + '<br/>')
    // }
    // box.insertAdjacentHTML('afterend', 'targetTouchesleng -> ' + eve.targetTouches.length + '<br/>')
    // for(let i = 0; i < eve.touches.length; i++) {
    //   box.insertAdjacentHTML('afterend', 'touches -> ' + eve.touches[i].innerText + '<br/>')
    // }
    // box.insertAdjacentHTML('afterend', 'touchesleng -> ' + eve.touches.length + '<br/>')
    
    // alert(eareBox.contains(target))
    if(res && !eareBox.contains(target)) {
      lineDrop.click()
      target.click()
    }
  }
}